// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__QY2dr","inner":"styles_inner___HdGt"};
module.exports.__checksum = "3aed0391f124"